import { render, staticRenderFns } from "./topUserManagement.vue?vue&type=template&id=a31405c4&scoped=true"
import script from "./topUserManagement.vue?vue&type=script&lang=js"
export * from "./topUserManagement.vue?vue&type=script&lang=js"
import style0 from "./topUserManagement.vue?vue&type=style&index=0&id=a31405c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31405c4",
  null
  
)

export default component.exports